// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileAppsDetails_root__OmKdg","header":"MobileAppsDetails_header__2TZhb","text":"MobileAppsDetails_text__57o9j","heading":"MobileAppsDetails_heading__litfF"};